import * as React from "react";
// import createHistory from "history/createBrowserHistory";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
// import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import NotFound from "./components/pages/NotFound";
import Login from "./components/pages/Login";
import App from "./App";
// const NODE_ENV = process.env.NODE_ENV;

// const history = createHistory();
const display = () => {
  return <Redirect to="/app/orderList" push />;
};

const initRouter = () => {
  const content = (
    <Switch>
      <Route exact path="/" render={display} />
      <Route path="/app" component={App} />
      <Route path="/404" component={NotFound} />
      <Route path="/login" component={Login} />
      <Route component={NotFound} />
    </Switch>
  );
  let rootRouter = <BrowserRouter>{content}</BrowserRouter>;
  // if (NODE_ENV == "beta_hash") {
  //   rootRouter = <HashRouter>{content}</HashRouter>;
  // }

  return rootRouter;
};

export default () => initRouter();
